<template>
  <div class="p-date-month-picker">
    <div class="mb-2">
      <p-row justify-center align-center nowrap>
        <p-button tertiary @click="addYear(-1)">
          <p-icon>chevron_left</p-icon>
        </p-button>
        <p-date-field v-model="yearDate" solo unit="year" @blur="updateVisibleYear(visibleYear)"></p-date-field>
        <p-button tertiary @click="addYear(1)">
          <p-icon>chevron_right</p-icon>
        </p-button>
      </p-row>
      <!-- <p-col justify-start align-center>
            <strong class="ml-4">{{ visibleYear }}</strong>
          </p-col>
          <p-col>
            <p-row dense justify-end align-center>
              <p-button dense tertiary @click="addYear(-1)">
                <p-icon>chevron_left</p-icon>
              </p-button>
              <p-button dense tertiary @click="addYear(1)">
                <p-icon>chevron_right</p-icon>
              </p-button>
            </p-row>
          </p-col> -->
    </div>
    <p-divider></p-divider>
    <p-container fluid class="p-date-picker-detail-panel">
      <p-row dense fill-height>
        <p-col
          v-for="monthTile in monthTiles"
          :key="monthTile.name"
          xs4
          md3
          justify-center
          align-center
        >
          <p-button
            stretch
            :disabled="isMonthDisabled(visibleYear, monthTile.monthNr)"
            :tertiary="!(selectedMonth === monthTile.monthNr)"
            @click="setSelectedMonth(monthTile.monthNr)"
          >
            <span>{{ monthTile.name }}</span>
          </p-button>
        </p-col>
      </p-row>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      value: { default: undefined, type: String },
      min: { default: undefined, type: String },
      max: { default: undefined, type: String },
    },
    data: () => ({
      monthTiles: [] as {name: string, monthNr: number}[],
      selectedMonth: undefined as number | undefined,
      visibleYear: Vue.$date.now().year() as number,
    }),
    computed: {
      yearDate: {
        get() {
          return `${this.visibleYear}-1-1`;
        },
        set(value: string) {
          this.visibleYear = this.$date(value)?.year();
        },
      },
    },
    watch: {
      value: {
        immediate: true,
        handler() {
          if (this.value) {
            const dateObj = this.$date(this.value);
            this.selectedMonth = dateObj.month() + 1;
            this.visibleYear = dateObj.year();
          }
        },
      },
    },
    beforeMount() {
      // Initialize once so it's not reloaded uneccessarily
      const tranlsation = this.$translation.get() === 'en' ? 'en': `${this.$translation.get()}-ch`;
      this.$date.locale(tranlsation);
      this.monthTiles = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((monthNr) => ({
        name: Vue.$date.now().month(monthNr).format('MMM'),
        monthNr: monthNr + 1,
      }));
    },
    methods: {
      isMonthDisabled(year: number, month: number) {
        const monthDateObj = this.$date(`${year}-${month}-1`);

        let minDateObj = this.$date(this.min);
        if (minDateObj) {
          // Min is always on the first day of the month
          minDateObj = minDateObj.date(1);
          if (minDateObj && monthDateObj?.isBefore(minDateObj)) {
            return true;
          }
        }

        let maxDateObj = this.$date(this.max);
        if (maxDateObj) {
          // Max is always on the last day of the month
          maxDateObj = maxDateObj.date(1).add(1, 'month').subtract(1, 'day');
          if (monthDateObj?.isAfter(maxDateObj)) {
            return true;
          }
        }

        return false;
      },
      setSelectedMonth(monthNr: number) {
        this.selectedMonth = monthNr;
        this.$emit('month-selected', this.selectedMonth);
        this.$emit('input', this.$date(`${this.visibleYear}-${this.selectedMonth}-1`).format('YYYY-MM-DD'));
      },
      updateVisibleYear(number: number) {
        this.$emit('visible-year-change', number);
      },
      addYear(number: number) {
        this.visibleYear += number;
        this.updateVisibleYear(this.visibleYear);
      },
    },
  });
</script>
